/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

/** @type {import('./min')} */
module.exports = Math.min;

